import { api } from '@rd-web-markets/shared/dist/services/service';
const cloudComputingsService = {
  get: cloud_computing => api.get(`/claims/${cloud_computing.claim_id}/cloud_computings/${cloud_computing.id}`),
  update: cloud_computing => api.update(`/claims/${cloud_computing.claim_id}/cloud_computings/${cloud_computing.id}`, cloud_computing),
  all: claimId => api.get(`/claims/${claimId}/cloud_computings`),
  delete: cloud_computing => api.delete(`/claims/${cloud_computing.claim_id}/cloud_computings/${cloud_computing.id}`),
  create: cloud_computing => api.create(`/claims/${cloud_computing.claim_id}/cloud_computings`, cloud_computing)
};
export default cloudComputingsService;